// extracted by mini-css-extract-plugin
module.exports = {"fontFamily":"\"Noto Sans JP\", sans-serif","fontFamilyTitle":"\"Sawarabi Mincho\", serif"};